import TransactionCreate from "@/controllers/transaction/transaction-create.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Select2Multiple from "v-select2-multiple-component";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import upLoad from "@/assets/img/upload_photo3.jpg";
import axios from "axios";
import store from "@/store";
import CONFIG from "@/assets/js/config.custom.js";
import tinycolor from "tinycolor2";
import {
    maxLength
} from "vuelidate/lib/validators";

export default {
    extends: TransactionCreate,
    components: {
        MainLayout,
        flatPickr,
        Select2Multiple,
    },

    data() {
        return {
            imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
            acaYear: null,
            inOutData: {
                type: null,
                title: "",
                payment_method_id: null,
                payment_date: "",
                amount: "",
                payment_screenshot: "",
                incharge_name: "",
                remark: "",
                loginID: "",
                campus_id: "",
                class_id: "",
                transaction_number: "",
                acd_year_id: this.$store.state.academicYear,
                transaction_category_id: null,
            },
            academic_year: "",
            classArr: null,
            academicYearArr: null,
            paymentMethodArr: null,
            submitted: false,
            ssImage: "",
            upLoad,
            campusId: store.state.user.campus_id,
            disabled: false,
            transactionCategoryArr: [],
            transactionTypesOptions: CONFIG.TRANSACTION_TYPES_OPTIONS,
        };
    },

    validations() {
        const baseValidations = typeof TransactionCreate.validations === 'function' 
                                    ? TransactionCreate.validations.call(this) 
                                    : TransactionCreate.validations || {};

        return {
            ...baseValidations,
            inOutData: {
                ...(baseValidations.inOutData || {}),
                transaction_number: {
                    maxLength: maxLength(100)
                }
            }
        };
    },

    computed: {
        transactionCategorySelectSettings() {
            return {
                multiple: false,
                placeholder: "Select Transaction Category",
                templateResult: (option) => this.formatTransactionCategoryOption(option),
                templateSelection: (option) => this.formatTransactionCategoryOption(option),
                escapeMarkup: (markup) => markup,
            };
        },

        /**
         * Check Payment Date Between Selected Academic Year
        */
        showDateWarning() {
            if (!this.inOutData.payment_date || !this.inOutData.acd_year_id || !this.academicYearArr) {
                return false;
            }
    
            const selectedYear = this.academicYearArr.find(y => y.id == this.inOutData.acd_year_id);
    
            if (selectedYear && selectedYear.start_date && selectedYear.end_date) {
                
                const payDate = new Date(this.inOutData.payment_date);
                const startDate = new Date(selectedYear.start_date);
                const endDate = new Date(selectedYear.end_date);

                return (payDate < startDate || payDate > endDate);
            }
    
            return false;
        }
    },

    watch: {
        'inOutData.type': function(newVal) {
            if (newVal) {
                this.getTransactionCategory(newVal);
            } else {
                this.transactionCategoryArr = [];
            }
        }
    },

    methods: {
        /**
         * Escape HTML
         * @param {string} text
         * @return {string}
         */
        escapeHtml(text) {
            return String(text ?? "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
        },

        /**
         * Validate Hex Color
         * @param {string} colorCode
         * @return {string}
         */
        validHexColor(colorCode) {
            const input = String(colorCode ?? "").trim();
            const standardHexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
            
            if (!standardHexRegex.test(input)) {
                return ""; 
            }
        
            const color = tinycolor(input);

            return color.isValid() ? color.toHexString() : "";
        },

        /**
         * Format Transaction Category Option
         * @param {object} option
         * @return {string}
         */
        formatTransactionCategoryOption(option) {
            if (!option || Number(option.id) === 0) {
                return this.escapeHtml(option?.text ?? "Select Transaction Category");
            }
            const safeText = this.escapeHtml(option.text);
            const safeColor = this.validHexColor(option.color_code);

            if (safeColor) {    
                return `<span style="display:flex;align-items:center;gap:8px;">
                            <span style="width:15px;height:15px;background:${safeColor};border:1px solid #d1d5db;display:inline-block;border-radius:2px;flex-shrink:0;"></span>
                            <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${safeText}</span>
                        </span>`;
            } else {
                return `<span style="display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;       max-width:100%;">${safeText}</span>`;
            }
        },

        /**
         * Get Category List with type
         * @param {string} type
         * @return {void}
         */
        getTransactionCategory(type) {  
            axios
                .get("/transactionCategory/getTransactionCategoryArray?type=" + type)
                .then((res) => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Transaction Category'
                    }];
                    const categoryList = Array.isArray(res.data?.[0]) ? res.data[0] : [];
                    const categoryOptions = categoryList.map((category) => {
                        return {
                            ...category,
                            text: category?.text ?? "",
                            color_code: category?.color_code ?? null,
                        };
                    });
                    this.transactionCategoryArr = $defaultSelectOption.concat(categoryOptions);
                })
                .catch((error) => {
                    if (error.response?.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    console.error("Error fetching categories:", error);
                });
        },

        /**
         * Create Transaction
         * @returns {void}
         */
        create() {
            if (this.disabled) return;
            this.submitted = true;

            if (this.$v && this.$v.$invalid) {
                return;
            }

            this.inOutData.payment_screenshot = this.ssImage;
            this.inOutData.loginID = this.$store.state.user.id;
            this.inOutData.campus_id = this.$store.state.user.campus_id;
            this.disabled = true;

            axios.post('transaction/create', this.inOutData)
                .then(res => {
                    if (res.data) {
                        this.$notification.success("Transaction Added Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.$router.push({ name: 'transactionList' });
                    }
                })
                .catch(error => {
                    this.disabled = false;
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else if (error.response.status == 422) {
                        this.$notification.error(error.response.data.error, {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                });
        },
    },
};
